import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class ApplicationConfigService {
	private endpointPrefix = '';
	private microfrontend = false;

	setEndpointPrefix(endpointPrefix: string): void {
		this.endpointPrefix = endpointPrefix;
	}

	setMicrofrontend(microfrontend = true): void {
		this.microfrontend = microfrontend;
	}

	isMicrofrontend(): boolean {
		return this.microfrontend;
	}

	getEndpointForWS(microservice?: string): string {
		return this.getEndpointFor(null, microservice);
	}

	getEndpointFor(api: string, microservice?: string): string {
		if (microservice && api) {
			return `${this.endpointPrefix}services/${microservice}/${api}`;
		} else if (microservice && !api) {
			return `${this.endpointPrefix}services/${microservice}`;
		}
		return `${this.endpointPrefix}${api}`;
	}
}
